import React from "react";
import { Patient } from "model/patient.model";
import { Gender } from "common/enums/GenderEnum";
import { Avatar, Icon, Media, Navbar } from "@cc/react-components";
import cn from "classnames";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  /** The patient to display*/
  patient: Patient;
  /** Whether or not to show the avatar */
  avatar?: boolean;
  /** Indicate where the info is placed */
  variant?: "header" | "page";
}

const PatientInfo = ({
  avatar,
  patient,
  variant = "page",
  ...props
}: Props) => {
  const renderGender = () => {
    return (
      <>
        {patient.gender === Gender.MALE && (
          <Icon type="male" className="ml-1" />
        )}
        {patient.gender === Gender.FEMALE && (
          <Icon type="female" className="ml-1" />
        )}
      </>
    );
  };

  const renderBodyContent = (textHandlingClass: string) => {
    return (
      <>
        <div className={cn(textHandlingClass, "font-weight-bold")}>
          {patientFullName} {renderGender()}
        </div>
        <div className="text-muted text-wrap">
          {patient.getAddressAsReadableString()}
        </div>
      </>
    );
  };

  const renderBody = () => {
    return (
      <>
        {variant === "header" && (
          <Navbar.Text>{renderBodyContent("text-truncate")}</Navbar.Text>
        )}
        {variant === "page" && (
          <div className="text-wrap">{renderBodyContent("text-wrap")}</div>
        )}
      </>
    );
  };

  const patientFullName = [
    patient.getNameAsReadableString(),
    patient.getAge(),
  ].join(", ");

  const renderContent = () => {
    return (
      <Media className="flex-grow-1">
        {avatar && (
          <Avatar
            trigram={patient.getInitials()}
            className="align-self-center mr-2"
            color="teal"
            size="sm"
          />
        )}
        <Media.Body>{renderBody()}</Media.Body>
      </Media>
    );
  };
  return <>{renderContent()}</>;
};

export default PatientInfo;
